export const filesToBase64 = (files: FileList | null | File[]): Promise<string> =>
  new Promise((resolve, reject) => {
    if (files) {
      const reader: any = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error: any) {
        reject(error);
      };
    } else {
      reject('No uploaded images');
    }
  });

export const dataURLtoFile = (dataurl: string, mime: string, filename: string) => {
  let arr: string[] = dataurl.split(',');
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const URLtoFile = async (url: string) => {
  const blob = await fetch(url).then(res => res.blob()).catch(() => undefined)
  if (blob) return new File([blob], "signature.png", { type: 'image/png' })
  else return blob
}